import React from 'react'
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material'
import { Assignment } from '@mui/icons-material'
import moment from 'moment'
import type { PatientHeaderProps } from './types'

const PatientHeader = React.memo(function PatientHeader({ quote }: PatientHeaderProps) {
  return (
    <Card elevation={3} sx={{ mb: 3 }}>
      <CardHeader
        title="Patient Information"
        avatar={<Assignment color="primary" />}
        sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}
        titleTypographyProps={{ color: 'inherit' }}
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body2" color="text.secondary">
              <strong>Patient Name:</strong>
            </Typography>
            <Typography variant="body1">{quote.patientName}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2" color="text.secondary">
              <strong>Date of Birth:</strong>
            </Typography>
            <Typography variant="body1">
              {moment(quote.dateOfBirth).format('L')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" color="text.secondary">
              <strong>Body Part:</strong>
            </Typography>
            <Typography variant="body1">{quote.bodyPart}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" color="text.secondary">
              <strong>EOC/Legacy:</strong>
            </Typography>
            <Typography variant="body1">{quote.eocLegacy}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
})

export default PatientHeader
